import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'
import { ROLEID } from '@GUTIL/hardCode'

export default {
  /**
   * Query
   */
  getAllSections: params => {
    const query = gql`
      query($in: SectionsFilterInput!) {
        allSections(in: $in) {
          data {
            id
            name
            addrs {
              id
              addr
              status
            }
            customer_services {
              id
              nickname
              username
            }
            creator {
              id
              username
            }
            updater {
              id
              username
            }
            addr_binding_mode
            channels {
              id
              name
            }
            exchange_type
            create_order_status
            created_at
            updated_at
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },

  getSection: params => {
    const query = gql`
      query($id: Int!) {
        section(id: $id) {
          id
          name
          addrs {
            id
            addr
            status
          }
          customer_services {
            id
            nickname
            username
          }
          addr_binding_mode
          channels {
            id
            name
          }
          exchange_type
          create_order_status
          # 取得配置客服下拉選單用
          divisions {
            customer_services {
              id
              nickname
              username
            }
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },

  getSectionSelectedOptions: () => {
    const query = gql`
      query($accountIn: AccountsFilterInput, $channelIn: ChannelFilterInput!) {
        allAccounts(filter: $accountIn) {
          data {
            id
            nickname
            username
          }
        }
        allChannel(in: $channelIn) {
          data {
            id
            name
            section {
              id
              name
            }
          }
        }
      }
    `
    return graphqlAjax('get', query, {
      accountIn: {
        role_ids: [ROLEID.CUSTOMER_SERVICE],
        base_filter: { page: 1, per_page: -1 }
      },
      channelIn: {
        base_filter: { page: 1, per_page: -1 }
      }
    })
  },

  getAllSectionAddressHistories: params => {
    const query = gql`
      query($in: SectionAddressHistoriesFilter!) {
        allSectionAddressHistories(in: $in) {
          data {
            address
            updated_at
            updater_name
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },

  /**
   * Mutation
   */
  createSection: (params, opts = {}) => {
    const mutation = gql`
      mutation($in: CreateSectionInput!) {
        createSection(in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },

  updateSection: (params, opts = {}) => {
    const mutation = gql`
      mutation($id: Int!, $in: UpdateSectionInput!) {
        updateSection(id: $id, in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  }
}
